import { useState } from "react";

const COLORS = {
  bg: "#060C18",
  blue: "#0066FF",
  cyan: "#00CFFF",
  orange: "#FF6B00",
  white: "#FFFFFF",
  muted: "#5A7A9A",
  border: "#0D1F35",
  card: "#0A1628",
};

// ── MODAL CONTRATISTA ──────────────────────────────────────────
function ModalContratista({ onClose }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    nombre: "", empresa: "", contratos_activos: "", contratos_año: "",
    alcaldia: "", residentes: "", mensaje: ""
  });

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const inputStyle = {
    width: "100%", background: "#0A1628", border: "1px solid #0D1F35",
    borderRadius: 8, padding: "12px 16px", color: "#fff",
    fontSize: 15, outline: "none", boxSizing: "border-box",
    fontFamily: "inherit"
  };

  const labelStyle = { color: COLORS.muted, fontSize: 13, marginBottom: 6, display: "block" };

  const whatsappMsg = encodeURIComponent(
    `Hola, soy ${form.nombre} de ${form.empresa}.\n\nTengo ${form.contratos_activos} contratos activos y manejo ~${form.contratos_año} contratos al año.\nTrabajo principalmente en: ${form.alcaldia}.\nEquipo de ${form.residentes} residentes.\n\n${form.mensaje}`
  );

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(6,12,24,0.95)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000, padding: 20
    }}>
      <div style={{
        background: COLORS.card, border: `1px solid ${COLORS.border}`,
        borderRadius: 16, padding: 32, maxWidth: 480, width: "100%",
        position: "relative"
      }}>
        <button onClick={onClose} style={{
          position: "absolute", top: 16, right: 16,
          background: "none", border: "none", color: COLORS.muted,
          fontSize: 22, cursor: "pointer"
        }}>✕</button>

        {/* Progress */}
        <div style={{ display: "flex", gap: 8, marginBottom: 28 }}>
          {[1, 2, 3].map(s => (
            <div key={s} style={{
              flex: 1, height: 3, borderRadius: 2,
              background: s <= step ? COLORS.orange : COLORS.border,
              transition: "background 0.3s"
            }} />
          ))}
        </div>

        {step === 1 && (
          <>
            <h2 style={{ color: "#fff", fontSize: 22, marginBottom: 8 }}>
              Cuéntanos de tu obra
            </h2>
            <p style={{ color: COLORS.muted, fontSize: 14, marginBottom: 24 }}>
              Para darte la mejor solución necesitamos conocer tu situación.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <label style={labelStyle}>Tu nombre</label>
                <input style={inputStyle} placeholder="Ej. Ing. Roberto Martínez"
                  value={form.nombre} onChange={e => update("nombre", e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Empresa o razón social</label>
                <input style={inputStyle} placeholder="Constructora..."
                  value={form.empresa} onChange={e => update("empresa", e.target.value)} />
              </div>
            </div>
            <button onClick={() => setStep(2)} style={{
              marginTop: 24, width: "100%", padding: "14px",
              background: COLORS.orange, border: "none", borderRadius: 10,
              color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer"
            }}>Continuar →</button>
          </>
        )}

        {step === 2 && (
          <>
            <h2 style={{ color: "#fff", fontSize: 22, marginBottom: 8 }}>
              Tu operación
            </h2>
            <p style={{ color: COLORS.muted, fontSize: 14, marginBottom: 24 }}>
              Esto nos ayuda a dimensionar exactamente qué necesitas.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <label style={labelStyle}>¿Cuántos contratos tienes activos ahorita?</label>
                <select style={{ ...inputStyle, cursor: "pointer" }}
                  value={form.contratos_activos} onChange={e => update("contratos_activos", e.target.value)}>
                  <option value="">Selecciona...</option>
                  <option>1</option><option>2 - 3</option>
                  <option>4 - 6</option><option>7 o más</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>¿Cuántos contratos manejas en promedio al año?</label>
                <select style={{ ...inputStyle, cursor: "pointer" }}
                  value={form.contratos_año} onChange={e => update("contratos_año", e.target.value)}>
                  <option value="">Selecciona...</option>
                  <option>1 - 3</option><option>4 - 8</option>
                  <option>9 - 15</option><option>Más de 15</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>¿En qué alcaldía o dependencia trabajas principalmente?</label>
                <input style={inputStyle} placeholder="Ej. Azcapotzalco, CDMX"
                  value={form.alcaldia} onChange={e => update("alcaldia", e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>¿Cuántos residentes tiene tu equipo?</label>
                <select style={{ ...inputStyle, cursor: "pointer" }}
                  value={form.residentes} onChange={e => update("residentes", e.target.value)}>
                  <option value="">Selecciona...</option>
                  <option>Solo yo</option><option>1 - 2</option>
                  <option>3 - 5</option><option>Más de 5</option>
                </select>
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
              <button onClick={() => setStep(1)} style={{
                flex: 1, padding: "14px", background: "none",
                border: `1px solid ${COLORS.border}`, borderRadius: 10,
                color: COLORS.muted, fontSize: 15, cursor: "pointer"
              }}>← Atrás</button>
              <button onClick={() => setStep(3)} style={{
                flex: 2, padding: "14px", background: COLORS.orange,
                border: "none", borderRadius: 10,
                color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer"
              }}>Continuar →</button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <h2 style={{ color: "#fff", fontSize: 22, marginBottom: 8 }}>
              ¿Qué necesitas resolver?
            </h2>
            <p style={{ color: COLORS.muted, fontSize: 14, marginBottom: 24 }}>
              Cuéntanos tu situación actual — entre más detalle, mejor podemos ayudarte.
            </p>
            <textarea
              style={{ ...inputStyle, minHeight: 120, resize: "vertical" }}
              placeholder="Ej: Tengo 2 contratos con 3 semanas de atraso en generadores, necesito entregar esta semana..."
              value={form.mensaje} onChange={e => update("mensaje", e.target.value)}
            />
            <a href={`https://wa.me/5215512345678?text=${whatsappMsg}`}
              target="_blank" rel="noreferrer"
              style={{
                display: "block", marginTop: 20, padding: "16px",
                background: "#25D366", borderRadius: 10, textAlign: "center",
                color: "#fff", fontSize: 16, fontWeight: 700,
                textDecoration: "none"
              }}>
              📲 Enviar por WhatsApp
            </a>
            <p style={{ color: COLORS.muted, fontSize: 12, textAlign: "center", marginTop: 12 }}>
              Respondemos en menos de 2 horas en horario de obra
            </p>
          </>
        )}
      </div>
    </div>
  );
}

// ── MODAL RESIDENTE ──────────────────────────────────────────
function ModalResidente({ onClose }) {
  const [form, setForm] = useState({
    nombre: "", experiencia: "", zona: "", disponibilidad: "", activo: ""
  });
  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const inputStyle = {
    width: "100%", background: "#0A1628", border: "1px solid #0D1F35",
    borderRadius: 8, padding: "12px 16px", color: "#fff",
    fontSize: 15, outline: "none", boxSizing: "border-box", fontFamily: "inherit"
  };
  const labelStyle = { color: COLORS.muted, fontSize: 13, marginBottom: 6, display: "block" };

  const whatsappMsg = encodeURIComponent(
    `Hola, me interesa ser parte de la red de residentes GenerIA.\n\nNombre: ${form.nombre}\nExperiencia: ${form.experiencia} años\nZona: ${form.zona}\nDisponibilidad: ${form.disponibilidad} días/semana\nSituación actual: ${form.activo}`
  );

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(6,12,24,0.95)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000, padding: 20
    }}>
      <div style={{
        background: COLORS.card, border: `1px solid ${COLORS.border}`,
        borderRadius: 16, padding: 32, maxWidth: 480, width: "100%",
        position: "relative"
      }}>
        <button onClick={onClose} style={{
          position: "absolute", top: 16, right: 16,
          background: "none", border: "none", color: COLORS.muted,
          fontSize: 22, cursor: "pointer"
        }}>✕</button>

        <div style={{
          display: "inline-block", background: `${COLORS.cyan}20`,
          border: `1px solid ${COLORS.cyan}40`, borderRadius: 20,
          padding: "4px 14px", color: COLORS.cyan, fontSize: 12,
          marginBottom: 16, fontWeight: 600
        }}>Red de Residentes GenerIA</div>

        <h2 style={{ color: "#fff", fontSize: 22, marginBottom: 8 }}>
          Gana dinero en tus tiempos libres
        </h2>
        <p style={{ color: COLORS.muted, fontSize: 14, marginBottom: 24 }}>
          Únete a nuestra red de residentes freelance y recibe encargos de generadores cerca de tu zona.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label style={labelStyle}>Tu nombre</label>
            <input style={inputStyle} placeholder="Ing. ..."
              value={form.nombre} onChange={e => update("nombre", e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>¿Cuántos años llevas como residente de obra?</label>
            <select style={{ ...inputStyle, cursor: "pointer" }}
              value={form.experiencia} onChange={e => update("experiencia", e.target.value)}>
              <option value="">Selecciona...</option>
              <option>Menos de 1 año</option><option>1 - 3 años</option>
              <option>3 - 7 años</option><option>Más de 7 años</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>¿En qué zona de CDMX trabajas normalmente?</label>
            <input style={inputStyle} placeholder="Ej: Azcapotzalco, Gustavo A. Madero..."
              value={form.zona} onChange={e => update("zona", e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>¿Cuántos días a la semana tienes disponibles?</label>
            <select style={{ ...inputStyle, cursor: "pointer" }}
              value={form.disponibilidad} onChange={e => update("disponibilidad", e.target.value)}>
              <option value="">Selecciona...</option>
              <option>1 - 2 días</option><option>3 - 4 días</option>
              <option>5 días completos</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>¿Tienes contratos activos o estás disponible?</label>
            <select style={{ ...inputStyle, cursor: "pointer" }}
              value={form.activo} onChange={e => update("activo", e.target.value)}>
              <option value="">Selecciona...</option>
              <option>Tengo obra activa pero tengo tiempo libre</option>
              <option>Estoy entre proyectos, disponible de inmediato</option>
              <option>Busco trabajo de tiempo completo</option>
            </select>
          </div>
        </div>

        <a href={`https://wa.me/5215512345678?text=${whatsappMsg}`}
          target="_blank" rel="noreferrer"
          style={{
            display: "block", marginTop: 24, padding: "16px",
            background: COLORS.cyan, borderRadius: 10, textAlign: "center",
            color: COLORS.bg, fontSize: 16, fontWeight: 700,
            textDecoration: "none"
          }}>
          📲 Quiero unirme al equipo
        </a>
      </div>
    </div>
  );
}

// ── LANDING PRINCIPAL ──────────────────────────────────────────
export default function Landing() {
  const [modal, setModal] = useState(null); // "contratista" | "residente"

  const sectionPad = { padding: "80px 24px", maxWidth: 960, margin: "0 auto" };

  return (
    <div style={{ background: COLORS.bg, minHeight: "100vh", fontFamily: "'Segoe UI', system-ui, sans-serif", color: "#fff" }}>

      {modal === "contratista" && <ModalContratista onClose={() => setModal(null)} />}
      {modal === "residente" && <ModalResidente onClose={() => setModal(null)} />}

      {/* NAV */}
      <nav style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "16px 24px", borderBottom: `1px solid ${COLORS.border}`,
        position: "sticky", top: 0, background: `${COLORS.bg}EE`,
        backdropFilter: "blur(12px)", zIndex: 100
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8,
            background: `linear-gradient(135deg, ${COLORS.blue}, ${COLORS.cyan})`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontWeight: 900, fontSize: 18, color: "#fff"
          }}>G</div>
          <span style={{ fontWeight: 800, fontSize: 18 }}>
            Gener<span style={{ color: COLORS.orange }}>IA</span>
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <a href="/login" data-testid="landing-login-btn" style={{
            background: "none", border: `1px solid ${COLORS.cyan}40`, borderRadius: 8,
            padding: "9px 18px", color: COLORS.cyan, fontWeight: 600,
            fontSize: 14, cursor: "pointer", textDecoration: "none", whiteSpace: "nowrap"
          }}>Iniciar sesión</a>
          <button onClick={() => setModal("contratista")} style={{
            background: COLORS.orange, border: "none", borderRadius: 8,
            padding: "10px 20px", color: "#fff", fontWeight: 700,
            fontSize: 14, cursor: "pointer"
          }}>Cuéntanos tu caso</button>
        </div>
      </nav>

      {/* HERO */}
      <section style={{ ...sectionPad, paddingTop: 100, paddingBottom: 100, textAlign: "center" }}>
        <div style={{
          display: "inline-block", background: `${COLORS.cyan}15`,
          border: `1px solid ${COLORS.cyan}30`, borderRadius: 20,
          padding: "6px 16px", color: COLORS.cyan, fontSize: 13,
          marginBottom: 24, fontWeight: 600
        }}>
          Servicio profesional de generadores · CDMX
        </div>

        <h1 style={{
          fontSize: "clamp(30px, 5.5vw, 62px)", fontWeight: 900,
          lineHeight: 1.1, marginBottom: 24
        }}>
          Llevas semanas sin cobrar porque<br />
          <span style={{ color: COLORS.orange }}>tus generadores no están listos.</span>
        </h1>

        <p style={{
          fontSize: "clamp(16px, 2.5vw, 20px)", color: COLORS.muted,
          maxWidth: 660, margin: "0 auto 40px", lineHeight: 1.7
        }}>
          Eso se acabó. Nosotros vamos a tu obra, levantamos todo y te entregamos
          los generadores en PDF listos para imprimir.
          Tú presentas, supervisión firma, y cobras.
        </p>

        <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => setModal("contratista")} style={{
            background: COLORS.orange, border: "none", borderRadius: 12,
            padding: "16px 32px", color: "#fff", fontWeight: 700,
            fontSize: 17, cursor: "pointer"
          }}>
            Quiero resolver esto ahora →
          </button>
          <button onClick={() => setModal("residente")} style={{
            background: "none", border: `1px solid ${COLORS.cyan}40`,
            borderRadius: 12, padding: "16px 32px", color: COLORS.cyan,
            fontWeight: 600, fontSize: 16, cursor: "pointer"
          }}>
            ¿Eres residente?
          </button>
        </div>
      </section>

      {/* EL DOLOR */}
      <section style={{ background: "#080E1C", padding: "80px 24px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, marginBottom: 48, textAlign: "center" }}>
            ¿Te suena familiar?
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 24 }}>
            {[
              { icon: "📋", text: "Tu obra le lleva semanas por delante a tus generadores." },
              { icon: "🔄", text: "Supervisión te devolvió el documento lleno de correcciones. Otra semana perdida." },
              { icon: "💸", text: "Cada corrección a tu generador es otra semana que no ves un peso." },
              { icon: "😤", text: "Tu residente tiene 3 obras encima. Los generadores siempre quedan para después." },
            ].map((item, i) => (
              <div key={i} style={{
                background: COLORS.card, border: `1px solid ${COLORS.border}`,
                borderRadius: 12, padding: 24
              }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{item.icon}</div>
                <p style={{ color: COLORS.muted, lineHeight: 1.6, margin: 0 }}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUÉ HACEMOS */}
      <section style={sectionPad}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64, alignItems: "center" }}>
          <div>
            <div style={{
              display: "inline-block", background: `${COLORS.cyan}15`,
              border: `1px solid ${COLORS.cyan}30`, borderRadius: 20,
              padding: "4px 14px", color: COLORS.cyan, fontSize: 12,
              marginBottom: 16, fontWeight: 600
            }}>Lo que hacemos</div>
            <h2 style={{ fontSize: 36, fontWeight: 800, lineHeight: 1.2, marginBottom: 20 }}>
              Hacemos tus generadores.<br />Tú armas tu estimación.
            </h2>
            <p style={{ color: COLORS.muted, lineHeight: 1.7, fontSize: 16, marginBottom: 24 }}>
              Vamos a tu obra, medimos, documentamos el avance y te entregamos
              los generadores en PDF listos para imprimir y presentar ante supervisión.
              Sin que tengas que explicarle nada a nadie.
            </p>
            <button onClick={() => setModal("contratista")} style={{
              background: COLORS.orange, border: "none", borderRadius: 10,
              padding: "14px 28px", color: "#fff", fontWeight: 700,
              fontSize: 15, cursor: "pointer"
            }}>Empezar ahora →</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {[
              { n: "01", title: "Nos das acceso a tu obra", desc: "Catálogo de conceptos y frentes de trabajo activos." },
              { n: "02", title: "Vamos al campo", desc: "Capturamos el avance real con mediciones precisas." },
              { n: "03", title: "Recibes el PDF listo para imprimir", desc: "Generador completo, personalizado para tu dependencia. Solo imprimes y presentas." },
              { n: "04", title: "Armas tu estimación y cobras", desc: "Sin retrasos, sin correcciones interminables." },
            ].map((s, i) => (
              <div key={i} style={{
                display: "flex", gap: 16, alignItems: "flex-start",
                background: COLORS.card, border: `1px solid ${COLORS.border}`,
                borderRadius: 12, padding: 20
              }}>
                <div style={{
                  minWidth: 36, height: 36, borderRadius: 8,
                  background: `${COLORS.cyan}15`, border: `1px solid ${COLORS.cyan}30`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: COLORS.cyan, fontWeight: 800, fontSize: 13
                }}>{s.n}</div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 4 }}>{s.title}</div>
                  <div style={{ color: COLORS.muted, fontSize: 14 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRÓXIMAMENTE - video placeholder */}
      <section style={{ background: "#080E1C", padding: "60px 24px" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <div style={{
            background: "#000", borderRadius: 16, aspectRatio: "16/9",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            border: `1px solid ${COLORS.border}`, overflow: "hidden"
          }}>
            <div style={{ fontSize: 13, letterSpacing: 6, color: COLORS.muted, textTransform: "uppercase", marginBottom: 16 }}>— En pantallas —</div>
            <div style={{ fontSize: "clamp(32px,6vw,56px)", fontWeight: 900, color: "#fff", letterSpacing: 4, fontStyle: "italic" }}>Próximamente</div>
            <div style={{ marginTop: 20, width: 48, height: 2, background: COLORS.orange }} />
          </div>
        </div>
      </section>

      {/* PERSONALIZACIÓN */}
      <section style={{ background: "#080E1C", padding: "80px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: 36, fontWeight: 800, marginBottom: 20 }}>
            Cada generador, hecho a tu medida.
          </h2>
          <p style={{ color: COLORS.muted, fontSize: 18, lineHeight: 1.7 }}>
            Trabajamos con el catálogo de conceptos de <em>tu</em> contrato
            y los requisitos específicos de <em>tu</em> dependencia.
            El resultado: un documento que tu supervisión acepta a la primera,
            sin correcciones, sin idas y venidas.
          </p>
        </div>
      </section>

      {/* URGENCIAS */}
      <section style={sectionPad}>
        <div style={{
          background: `linear-gradient(135deg, ${COLORS.cyan}10, ${COLORS.card})`,
          border: `1px solid ${COLORS.cyan}20`, borderRadius: 20,
          padding: "56px 48px", textAlign: "center"
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚡</div>
          <h2 style={{ fontSize: 36, fontWeight: 800, marginBottom: 16 }}>
            ¿Tienes una entrega urgente?
          </h2>
          <p style={{ color: COLORS.muted, fontSize: 18, lineHeight: 1.6, maxWidth: 560, margin: "0 auto 32px" }}>
            ¿Tu supervisión te está esperando y no tienes el generador?
            Mándanos un mensaje ahorita. En menos de 2 horas te decimos
            si podemos resolverlo hoy.
          </p>
          <button onClick={() => setModal("contratista")} style={{
            background: COLORS.orange, border: "none", borderRadius: 12,
            padding: "16px 36px", color: "#fff", fontWeight: 800,
            fontSize: 18, cursor: "pointer"
          }}>
            Necesito esto para ayer →
          </button>
        </div>
      </section>

      {/* RED DE RESIDENTES */}
      <section style={{ background: "#080E1C", padding: "80px 24px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" }}>
            <div>
              <div style={{
                display: "inline-block", background: `${COLORS.cyan}15`,
                border: `1px solid ${COLORS.cyan}30`, borderRadius: 20,
                padding: "4px 14px", color: COLORS.cyan, fontSize: 12,
                marginBottom: 16, fontWeight: 600
              }}>Para residentes</div>
              <h2 style={{ fontSize: 32, fontWeight: 800, lineHeight: 1.2, marginBottom: 16 }}>
                Gana dinero en tus tiempos libres
              </h2>
              <p style={{ color: COLORS.muted, lineHeight: 1.7, marginBottom: 24 }}>
                ¿Tienes experiencia en obra pública y tiempo disponible?
                Únete a nuestra red de residentes freelance y recibe
                encargos de generadores cerca de tu zona.
              </p>
              <button onClick={() => setModal("residente")} style={{
                background: "none", border: `1px solid ${COLORS.cyan}40`,
                borderRadius: 10, padding: "14px 28px", color: COLORS.cyan,
                fontWeight: 700, fontSize: 15, cursor: "pointer"
              }}>Quiero unirme →</button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                "Trabajos cerca de tu zona",
                "Tú decides cuándo y cuánto trabajas",
                "Pago por trabajo entregado",
                "Sin contratos ni compromisos fijos",
              ].map((b, i) => (
                <div key={i} style={{
                  display: "flex", alignItems: "center", gap: 12,
                  background: COLORS.card, border: `1px solid ${COLORS.border}`,
                  borderRadius: 10, padding: "14px 18px"
                }}>
                  <span style={{ color: COLORS.cyan, fontSize: 18 }}>✓</span>
                  <span style={{ color: "#ccc", fontSize: 15 }}>{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ ...sectionPad, textAlign: "center" }}>
        <h2 style={{ fontSize: 40, fontWeight: 900, marginBottom: 16 }}>
          ¿Listo para armar tu estimación a tiempo?
        </h2>
        <p style={{ color: COLORS.muted, fontSize: 18, marginBottom: 36 }}>
          Cuéntanos tu situación y en menos de 2 horas te decimos cómo podemos ayudarte.
        </p>
        <button onClick={() => setModal("contratista")} style={{
          background: COLORS.orange, border: "none", borderRadius: 14,
          padding: "18px 44px", color: "#fff", fontWeight: 800,
          fontSize: 20, cursor: "pointer"
        }}>
          Cuéntanos tu caso →
        </button>
      </section>

      {/* FOOTER */}
      <footer style={{
        borderTop: `1px solid ${COLORS.border}`, padding: "32px 24px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        flexWrap: "wrap", gap: 16
      }}>
        <div>
          <span style={{ fontWeight: 800, fontSize: 16 }}>
            Gener<span style={{ color: COLORS.orange }}>IA</span>
          </span>
          <span style={{ color: COLORS.muted, fontSize: 13, marginLeft: 12 }}>
            by TANGIBLE Tech · CDMX
          </span>
        </div>
        <div style={{ color: COLORS.muted, fontSize: 13 }}>
          generia.mx · atencion@generia.mx
        </div>
      </footer>

    </div>
  );
}
